
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uploadData/serialNo",
      function () {
        return require("private-next-pages/uploadData/serialNo.tsx");
      }
    ]);
  